import React, { Component } from "react";
import Close from "../../../../../Icons/Close";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';

class ModaleArchivage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
      fromArchive: window.location.pathname.includes("archives"),
    };
    this.ArchiverFichier = this.ArchiverFichier.bind(this);
  }

  closeModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onCloseModaleArchive();
    }, 400);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  ArchiverFichier = () => {
    this.setState({ styleFadeIn: false });
    this.props.onSubmitArchive();
  };

  render() {
    const { fromArchive } = this.state;
    return (
      <StyleRoot>
        <div
          class="modal fade modal-skin show actif"
          id="modalArchive"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closeModal}
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">
                      {fromArchive ? this.props.t('fiche_enfant.recover_fiche') : this.props.t('fiche_enfant.archive_fiche')}
                    </h5>
                  </section>
                  <section>
                    <h5>
                      {fromArchive
                        ? this.props.t('fiche_enfant.recover_fiche_confirm')
                        : this.props.t('fiche_enfant.archive_fiche_confirm')}
                    </h5>
                  </section>
                  <p className="bottom-space"></p>
                  <section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-confirm"
                        onClick={this.ArchiverFichier}
                      >
                        <img
                          src="img/icon-check-white.svg"
                          className="img-fluid"
                          alt=""
                        />{" "}
                        {this.props.t('common.confirm')}
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
export default withTranslation()(ModaleArchivage);
